import { AnimatedSprite, Loader } from 'pixi.js';
export default class AnimatedElement {
    constructor(stage, frames, position, size, speed, enabled, staticFrameNumber, zIndex, onResourcesLoaded) {
        this.stage = stage;
        this.staticFrameNumber = staticFrameNumber;
        this.enabled = enabled;

        this.loader = new Loader();
        frames.forEach((frame) => this.loader.add(frame, frame));

        this.loader.load((loader) => {
            const textures = [];
            frames.forEach((key) => textures.push(loader.resources[key].texture));

            this.sprite = new AnimatedSprite(textures);
            this.sprite.visible = false;
            this.sprite.x = position.x;
            this.sprite.y = position.y;
            this.sprite.width = size.width;
            this.sprite.height = size.height;
            this.sprite.zIndex = zIndex;
            this.sprite.animationSpeed = speed;
            this.sprite.loop = false;
            this.stage.addChild(this.sprite);
            this.animationCompleted = false;
            this.sprite.onComplete = () => {
                this.animationCompleted = true;
            }

            if (onResourcesLoaded) {
                onResourcesLoaded();
            }
        })
    }


    update(enabled, position, size) {
        if (!this.sprite) return;
        
        if (enabled != undefined) {
            this.enabled = enabled;
            this.sprite.visible = enabled;

            if (!enabled) {
                this.sprite.gotoAndStop(0);
                this.animationCompleted = false;
            }
        }

        if (position !== undefined) {
            if (this.sprite?.x != position.x || this.sprite?.y != position.y) {
                this.sprite.gotoAndStop(0);
                this.animationCompleted = false;
           }

            this.sprite.x = position.x;
            this.sprite.y = position.y;
        }

        if (size !== undefined) {
            this.sprite.width = size.width;
            this.sprite.height = size.height;
        }
    }

    draw(playingPreview) {
        if (!this.sprite) return;
        
        if (this.enabled) {
            if (playingPreview && !this.sprite.playing && !this.animationCompleted) {
                this.sprite.gotoAndPlay(0);
                return;
            }

            if (!playingPreview) {
                this.sprite.gotoAndStop(this.staticFrameNumber);
                this.animationCompleted = false;
            }
        }
    }

    updateStage(stage) {
        this.stage = stage;
        this.stage.addChild(this.sprite);
    }

    destroy() {
        this.sprite?.destroy();
    }
}